/**
 * Shared map UI state and DOM refs (underscore basename: not a separate Laravel Mix entry).
 */

export const mapElement = document.getElementsByClassName('carte-layout__map');
export const searchInput = document.getElementsByClassName('js-map-search');
export const categSelects = document.getElementsByClassName('js-choose-categ');
export const mapVenueCards = document.getElementsByClassName('map-venue-card');
export const sidePanelOfCategs = document.getElementsByClassName('side-panel__categories');
export const noResultsText = document.getElementsByClassName('side-panel__no-results');
export const noResultsTextMessage =
    noResultsText[0] ? noResultsText[0].innerHTML : 'Aucun résultats.';

export const boundsboxArray = typeof boundsbox !== 'undefined' ? boundsbox.split(',') : [];

export const $side_panel = document.querySelector('.side-panel');
export const $carte_layout = document.querySelector('.carte-layout');

export const queryString = window.location.search;
export const urlParams = new URLSearchParams(queryString);

export let map = null;
export let bounds = null;
export let clusters = null;
export let $dataPanelTns = null;
export let markerMode = 'basic';
export let infowindow = null;
export let infowindowTimeout = null;
export let highlightZone = null;

export function setMap(v) {
    map = v;
}
export function setBounds(v) {
    bounds = v;
}
export function setClusters(v) {
    clusters = v;
}
export function setDataPanelTns(v) {
    $dataPanelTns = v;
}
export function setMarkerMode(v) {
    markerMode = v;
}
export function setInfowindow(v) {
    infowindow = v;
}
export function setInfowindowTimeout(v) {
    infowindowTimeout = v;
}
export function setHighlightZone(v) {
    highlightZone = v;
}
